export const SET_TOKEN = 'SET_TOKEN'
export const RESET_TOKEN = 'RESET_TOKEN'
export const SET_USER_INFO = 'SET_USER_INFO'
export const GET_USER_INFO = 'GET_USER_INFO'
export const GET_USER_INFO_ERROR = 'GET_USER_INFO_ERROR'
export const GET_WORKSPACES = 'GET_WORKSPACES'
export const SET_WORKSPACES = 'SET_WORKSPACES'
export const SET_ACTIVE_WORKSPACE = 'SET_ACTIVE_WORKSPACE'
export const SET_USER_TYPE = 'SET_USER_TYPE'
export const SET_PROFILE_INFO = 'SET_PROFILE_INFO'
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION'
export const SET_NOTIFICATION_SIDEBAR_COUNT = 'SET_NOTIFICATION_SIDEBAR_COUNT'
